/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export const ERROR_OK = "ok";
export const ERROR_UNKNOWN = "unknown";
export const ERROR_PERMANENT = "permanent";
export const ERROR_TEMPORARY = "temporary";

export const ERROR_TYPES = {
    [ERROR_OK]: {
        name: "Ok",
    },
    [ERROR_PERMANENT]: {
        name: "Permanent"
    },
    [ERROR_TEMPORARY]: {
        name: "Temporary"
    },
    [ERROR_UNKNOWN]: {
        name: "Unknown",
    },
};

export const ERROR_RESOLVE_BY_CUSTOMER = "customer";
export const ERROR_RESOLVE_BY_DATIVERY = "dativery";
export const ERROR_RESOLVE_BY_PRODUCER = "producer";

export const ERROR_RESOLVABLE_BY = {
    [ERROR_RESOLVE_BY_CUSTOMER]: {
        name: "Customer"
    },
    [ERROR_RESOLVE_BY_DATIVERY]: {
        name: "Dativery"
    },
    [ERROR_RESOLVE_BY_PRODUCER]: {
        name: "Application Producer"
    },
};

export default declareLinkedEntity({
    entity: "channelErrorDefs",
    graphQL: "ChannelErrorDef",
    name: "Channel Error Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: 'channelErrorDefs',
    defaultOrder: ['name', 'title'],
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Channel Error ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['id'];
            },
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        channelDefVersion: {
            name: "Channel Definition Version",
            to: () => types['channelDefVersions'],
            type: "relation",
            defaultValue: (channelDef) => {
                return channelDef['channelDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        name: {
            name: "Name",
            type: "string",
            trim: true,
            translatable: true,
            defaultValue: "",
        },
        title: {
            name: "Title",
            type: "string",
            trim: true,
            translatable: true,
            defaultValue: "",
            description: "You can use variables $1, $2, $3, ...",
        },
        type: {
            name: "Type",
            type: "enum",
            values: ERROR_TYPES
        },
        resolvableBy: {
            name: "Resolvable by",
            type: "enum",
            values: ERROR_RESOLVABLE_BY,
        },
        sendToClient: {
            name: "Send to client",
            type: "boolean",
            defaultValue: false,
        },
        regexps: {
            name: "Regexps",
            type: "text",
            defaultValue: "",
        },
        fieldNames: {
            name: "Field names",
            type: "text",
            defaultValue: "",
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: "",
            description: "You can use variables $1, $2, $3, ...",
        },
        resolution: {
            name: "Resolution",
            type: "text",
            trim: true,
            translatable: true,
            defaultValue: "",
            description: "You can use variables $1, $2, $3, ...",
        },
        developersNotes: {
            name: "Developer's notes",
            type: "text",
            defaultValue: "",
            permission: Permission.PERM_EDIT_CHANNEL_DEF,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
